<template>
<div>
    <label style="margin-bottom: 10px;">{{ $t('day_types.exceptions') }}</label>
    <b-row v-if="$UIPrivilege('timetables/daytypes', 'update.exceptions')"> 
        <b-col cols="6">
            <b-form-datepicker v-model="datepick" :locale="locale" start-weekday="1" v-bind="dateTranslations || {}"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
        </b-col>
        <b-col>
            <b-form-group>
                <b-form-radio v-model="typepick" :value="1"><span class='valid'>{{ $t('day_types.exception.added') }} </span></b-form-radio>
                <b-form-radio v-model="typepick" :value="2"><span class='not-valid'>{{ $t('day_types.exception.removed') }}</span></b-form-radio>
            </b-form-group>
        </b-col>
        <b-col>
            <p-button @click="onAddException" type="default" size="sm" outline class="float-right"><i class="fa fa-plus" style="margin: 0px;"></i></p-button>
        </b-col>
    </b-row>
    <b-table
        small
        striped
        :fields="dayTypeCalendarFields"
        :items="value"
        thead-class="d-none"
        tbody-tr-class="calendar-list-bodytr">
        <template v-slot:cell(type)="data">
            <span v-if="data.value=='1'" class='valid'><b-icon icon="calendar-plus" /> {{ $t('day_types.exception.added') }}</span>
            <span v-if="data.value=='2'" class='not-valid'><b-icon icon="calendar-minus" /> {{ $t('day_types.exception.removed') }}</span>
        </template>
        <template v-slot:cell(actions)="data">
            <b-icon v-if="$UIPrivilege('timetables/daytypes', 'update.exceptions')" :title="$t('day_types.remove')"
                icon="x" variant="danger" style="cursor: pointer;" @click="onRemoveException(data.item.date)" scale='2'/>
        </template>
    </b-table>
</div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'DayTypeCalendarEditor',
    props: {
        value: {        
            default: () => []
        }
    },
    data: function() {
        return  {
            datepick: null,
            typepick: 1
        };
    },
    computed: {
        dayTypeCalendarFields() {
            return [
                { key: 'date', label: this.$t('day_types.date'), sortable: false, formatter: this.formatDate },
                /*
                { key: 'type', label: this.$t('day_types.type'), sortable: false, formatter: (value) => {
                    return value == 1 ? this.$t('day_types.exception.added') : this.$t('day_types.exception.removed');
                }},
                */
                { key: 'type', label: this.$t('day_types.type'), sortable: false },
                { key: 'actions', label: this.$t('day_types.actions'), sortable: false, tdClass: 'text-right' }
            ];
        },
        locale() {
            return this.$t('datepicker.locale');
        },
        dateTranslations() {
            return this.$t('datepicker');
        }
    },
    methods: {
        onAddException() {
            if (this.datepick != null) {
                var m = moment(this.datepick, 'YYYY-MM-DD');
                if (m.isValid()) {
                    let newCalendars = [];
                    let found = false;
                    for (const dtc of this.value) {
                        if (dtc.date != this.datepick) {
                            newCalendars.push(dtc);
                        } else {
                            found = true;
                            newCalendars.push({ date: this.datepick, type: this.typepick });
                        }
                    }
                    if (!found) {
                        newCalendars.push({ date: this.datepick, type: this.typepick });
                    }
                    newCalendars.sort((a, b) => {
                        if (a.date > b.date) return 1;
                        if (a.date < b.date) return -1;
                        return 0;
                    });
                    this.$emit('input', newCalendars);
                }
            }
        },
        onRemoveException(date) {
            let calendars = [];
            for (const c of this.value) {
                if (c.date != date) {
                    calendars.push(c);
                }
            }
            this.$emit('input', calendars);
        },
        formatDate(date) {
            return new moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
        }
    }
}
</script>

<style lang="scss">
.calendar-list-headtr {
    visibility: none;
}

.calendar-list-bodytr td {
    font-family: Verdana,Arial,Helvetica,sans-serif;
    font-size: 12px;
    padding: 5px 5px !important;
    font-weight: bold;
}

.valid {
    color: green;
}

.not-valid{
    color: red;
}



</style>